var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-swipe',{attrs:{"vertical":true,"show-indicators":false,"autoplay":5000}},_vm._l((_vm.data),function(item,index){return _c('van-swipe-item',{key:index},[_vm._t("default",null,{"item":item,"index":index})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }